<template>
  <g-master name="typeofevaluation"
            :endpoint="shiftMaster.endpoint"
            :tableSetup="shiftMaster.tableSetup"
            :modalFieldsSetup="shiftMaster.modalFieldsSetup"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" label="Descripción">
            <a-input
              v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        shiftMaster: {
          endpoint: 'type_evaluation',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_type_evaluation'
            },
            columns: [
              {title: 'Descripcion', dataIndex: 'description', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'description'},
          ],
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Evaluaciones/TipoEvaluacion.vue